import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classNames } from 'utils/classNames';

import WorkspaceTopbarTitle from './WorkspaceTopbarTitle';
import WorkspaceTopbarSaveButton from './WorkspaceTopbarSaveButton';
import WorkspaceTopbarDropdown from './WorkspaceTopbarDropdown';
import WorkspaceTopbarPreview from './WorkspaceTopbarPreview';

const baseClassName = 'WorkspaceTopbar';

class WorkspaceTopbar extends Component {
    render() {
        const { children, className, backgroundColor, useLightMode } = this.props;

        const topBarClassNames = classNames({
            [baseClassName]: true,
            [className]: className,
            [`${baseClassName}--light-mode`]: useLightMode,
        });

        return (
            <nav className={topBarClassNames} style={backgroundColor ? { backgroundColor } : null}>
                {children}
            </nav>
        );
    }
}

WorkspaceTopbar.Title = WorkspaceTopbarTitle;
WorkspaceTopbar.SaveButton = WorkspaceTopbarSaveButton;
WorkspaceTopbar.Dropdown = WorkspaceTopbarDropdown;
WorkspaceTopbar.Preview = WorkspaceTopbarPreview;

WorkspaceTopbar.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    backgroundColor: PropTypes.string,
    useLightMode: PropTypes.bool,
};

WorkspaceTopbar.defaultProps = {
    children: null,
    className: '',
    backgroundColor: null,
    useLightMode: false,
};

export default WorkspaceTopbar;
